function headScript(gtmId) {
    return `/* Google Tag Manager */(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmId}');/* End Google Tag Manager */`;
}

function bodyScript(gtmId) {
    return `<!-- Google Tag Manager (noscript) --><iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe><!-- End Google Tag Manager (noscript) -->`;
}

export default ({ level = 'head', gtmId = null } = {}) => {
    if (gtmId) {
        if (level === 'head') {
            const head = document.head;
            if (!head) {
                return;
            }

            const scriptEle = document.createElement('script');
            scriptEle.type = 'text/javascript';
            scriptEle.innerText = headScript(gtmId);

            head.appendChild(scriptEle);
        } else if (level === 'body') {
            const body = document.body;
            if (!body) {
                return;
            }

            const noscriptEle = document.createElement('noscript');
            noscriptEle.innerText = bodyScript(gtmId);
            body.appendChild(noscriptEle);
        }
    }
};
